import React from 'react';
import { View } from 'react-native';
import LanguageButton from '../LanguageButton';

import styles from './styles';
import type { LanguageSelectorProps } from '../LanguageSelector';

interface LanguageButtonsProps {
    languages: LanguageSelectorProps['languages'];
    currentLanguage: LanguageSelectorProps['currentLanguage'];
    onSelect: LanguageSelectorProps['onSelect'];
}

const LanguageButtons = ({
    languages,
    currentLanguage,
    onSelect
}: LanguageButtonsProps): JSX.Element => (
    <View style={styles.languageSelect}>
        {languages.map((language) => (
            <LanguageButton
                key={language}
                label={language}
                isSelected={language === currentLanguage}
                onSelect={onSelect}
            />
        ))}
    </View>
);

export default LanguageButtons;
